<template>
  <div class="inner-page course-player-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header">
        <header-right slot="right"></header-right>
      </app-header>
      <a-spin size="large" :spinning="isLoading">
      <div class="course-player-main" slot="default">
        <div class="course-player-bg">
          <!-- <breadcrumb :navList="false"></breadcrumb> -->
          <div class="content">
            <div class="content--left">
              <video-player
                v-if="playerOptions.sources[0].src !== 'first'"
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :events="events"
                @pause="onPause"
                @ended="onEnded"
                @timeupdate="onPlayerTimeupdate"
                @ready="playerReadied"
                @fullscreenchange="onFullscreenChange"
                :playsinline="true"
                :options="playerOptions"/>
            </div>
            <div class="content--right">
              <div class="title-box">
                <h5 class="title">{{videoInfo.title}}</h5>
                <!-- <h6 class="date">{{`课程有效期：${videoInfo.expire_time}`}}</h6> -->
                <h6 class="date">{{`课程上传日期：${videoInfo.created_time}`}}</h6>
              </div>
              <div class="tag-list">
                <!-- <a-tag class="tag" :color="getColor(index)" v-for="(item, index) in videoInfo.tags" :key="index">
                  {{item}}
                </a-tag> -->
              </div>
              <div class="introduce-box" v-html="videoInfo.desc"></div>
              <div class="button-wrap">
				<div class="button-wrap-first">
					<a-button type="primary" @click="clickButton('discuss')">活动小游戏</a-button>
				</div>
                <a-button type="primary" class="desc-button" @click="clickContentButton('desc')">活动指导</a-button>
                <a-button type="primary" class="desc-button" @click="clickContentButton('ext')">讨论环节及拓展知识</a-button>
              </div>
            </div>
          </div>
		  <breadcrumb :navList="navList"></breadcrumb>
		  
        </div>
      </div>
      </a-spin>
      <a-modal
		@cancel="handleClose"
        :footer="null"
        :title="infoTitle"
        v-model="dialogVisible"
        :centered="true"
        dialogClass="custom__dialog custom__dialog--w1000"
      >
		<a-button class="downloadButton" type="primary" @click="clickButton('download')">下载文档</a-button>
        <div :class="['text', videoInfo.content ? '' : 'textAlignCenter']" v-html="infoContent"></div>
		<template slot="closeIcon">
		      <img class="closeImg" src="../assets/images/common/close.png" alt="">
		    </template>
      </a-modal>
    </app-layout>
  </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import Breadcrumb from '../components/breadcrumb/breadcrumb.vue'
import indexConfig from "@/config/url.config";
import { course } from '@/api'
import urlConfig from '../config/url.config';

export default {
  name: 'coursePlayer',
  components: { HeaderRight, Breadcrumb },
  data () {
    return {
      videoInfo: {},
      tagsColor: ['#CE2323', '#811FC4', '#F28306', '#EC7D7D', '#2362CE'],
      events: ['fullscreenchange'],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'first'
        }],
        poster: '',
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true,
          // volumeControl: true,
        }
      },
      isLoading: true,
      dialogVisible: false,
	  infoTitle:"视频拓展知识及参考文献",
	  infoContent:"",
	  infoDownloadUrl:"",
	  infoDownloadName:"",
    }
  },
  computed: {
    navList () {
      return [
        {
          text: '返回首页'
        },
        {
          text: this.videoInfo.title
        }
      ]
    },
  },
  created () {
    let { id } = this.$route.query || {}
    this.currentId = id
    Promise.all([this.getVideoInfo(id)]).then(() => {
      
    }).catch(() => {
      this.$message.error('请求数据失败')
    }).finally(() => {
      this.isLoading = false
    })
  },
  beforeDestroy() {
    this.player && this.player.hasStarted_ && this.saveWatchedTime()
  },
  mounted () {
  },
  methods: {
	handleClose(e){
		// 选择页面上所有的video元素
		var videos = document.querySelectorAll('video');
		// 遍历所有video元素并停止播放
		videos.forEach(function(video) {
		  video.pause();
		});
	},
	clickContentButton(type){
		switch(type) {
		  case "desc": //讲解说明
			this.infoTitle = '课程内容讲解说明'
			this.infoContent = this.videoInfo.content_explanation
			this.infoDownloadUrl = this.videoInfo.download_url_content
			this.infoDownloadName = this.videoInfo.download_name_content
			this.dialogVisible = true
		  break
		  case "ext": //视频拓展知识及参考文献
			this.infoTitle = '视频拓展知识及参考文献'
			this.infoContent = this.videoInfo.content
			this.infoDownloadUrl = this.videoInfo.download_url_ext
			this.infoDownloadName = this.videoInfo.download_name_ext
			this.dialogVisible = true
		  break
		}
	},
	clickButton(type){
	  switch(type) {
		  case "download":
		  if (this.videoInfo && this.infoDownloadUrl) {
			  this.downloadFile(this.infoDownloadUrl, this.infoDownloadName)
		  } else {
			  this.$message.error("暂无文档")
		  }
		  break
		  case "discuss": //讨论环节
			if (this.videoInfo.game_url) {
				window.open(this.videoInfo.game_url)
			}
		  break
	  }
	},
	downloadFile(url, name) {
		const link = document.createElement('a');
		 link.style.display = 'none';
		 link.href = url
		 link.download = name
		 //将a标签添加到文档对象中
		 document.body.appendChild(link);
		 //触发相应事件
		 link.click();
		 //移除a标签
		 link.remove();
	},
    async getVideoInfo (id) {
      let parmas = { id: id }
      let detail = await this.getVideoDetail(parmas)
      return this.getVideoSrc(detail.video_id)
    },
    getVideoDetail (parmas) {
      return course.detail(parmas).then(res => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.videoInfo = data
        this.playerOptions.poster = data.img
        return data
      })
    },

    getVideoSrc (videoId) {
      return course.video({videoId}).then(res => {
        let { data, status, msg = '' } = res || {}

        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        
        this.playerOptions.sources[0].src = data.playUrl
        Object.assign(this.videoInfo, data)
        return data
      })
    },
    getColor (index) {
      let num = index % 5
      let color = this.tagsColor[num]
      return color
    },
    onFullscreenChange(e) {
      let fullScreenObj = e.controlBar.fullscreenToggle || {}

      if (this.player.isFullscreen()) {
        fullScreenObj.controlText('取消全屏')
      } else {
        fullScreenObj.controlText('全屏')
      }
    },
    onPause () {
      this.saveWatchedTime()
    },
    onEnded () {
      this.saveWatchedTime()
    },
    onPlayerTimeupdate (player) {
      this.currentTime = player.cache_.currentTime
    },
    playerReadied (player) {
      let time = this.videoInfo.watchedTime || 0
      // let duration = player.duration()
      this.player = player
      player.currentTime(time)

      let fullScreenObj = player.controlBar.fullscreenToggle || {}
      fullScreenObj.controlText('全屏')
    },
    saveWatchedTime () {
      let params = {
        videoId: this.videoInfo.video_id,
        watchedTime: this.currentTime
      }
      course.saveWatchedTime(params).then(res => {
        let { status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/style/index";
  ::v-deep .ant-spin-blur{
	  height: 100vh;
  }
  ::v-deep .vjs-poster{
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
  }
  ::v-deep .layout > .main.auto{
	  background-color: @mainBgColor;
	  .bgByMedia('/index/bg', 'png');
	  min-height: 788px;
	  width: 1920px;
	  background-size: 100% auto;
	  background-repeat: no-repeat;
	  background-position: 0 0;
  }
  .downloadButton {
  	position: absolute;
  	top: 30px;
  	right: 100px;
  }
  .course-player-page{
	  @rightWight : 400px;
	  @leftWight : calc(100% - @rightWight);
	  //916
	  @height : 872px;
	  
	  .course-player-main{
		  display: flex;
		  flex-direction: column;
		  justify-content: center;
		  height: calc(100vh - @header-height - 1px);
		  padding-top: @bread-height;
	  }
    .course-player-bg{
      font-family: 'SourceHanSansCN-Medium';
      // .bgByMedia('/index/bg', 'png');
      // min-height: 788px;
      // width: 1920px;
      // background-size: 100% auto;
      // background-repeat: no-repeat;
      // background-position: 0 0;

      .content{
        width: 100%;
        margin: 0 auto 0;
        background-color: @contentBgColor;
        display: flex;
        justify-content: space-between;
        &--left{
          width: @leftWight;
          height: @height;
		  display: flex;
		  flex-direction: column;
		  justify-content: center;
        }
        &--right{
          width: @rightWight;
          height: @height;
          overflow: auto;
          padding: 20px 20px 20px 20px;
          position: relative;
          .title-box{
            padding: 0 0 20px 0;
            border-bottom: 1px solid rgba(64, 65, 76, 1); /*no*/
            .title{
              color: @titleColor;
              font-size: 20px;
              margin: 0;
              .ellipsis();
            }
            .date{
              font-size: 14px;
              color: @dateColor;
              padding-top: 14px;
              margin: 0;
            }
          }
          .tag-list{
            display: flex;
            flex-wrap: wrap;
            padding: 0px 0 18px;

            .tag{
              margin-top: 18px;
            }
          }
          .introduce-box{
            text-indent: 30px;
            font-size: 17px;
            color: @textColor;
            line-height: 26px;
            overflow: hidden;
          }
          .button-wrap{
            margin-top: 20px;
            text-align: center;
            position: absolute;
            bottom: 0;
            left: 20px;
            width: calc(@rightWight - 40px);
			.button-wrap-first{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				button{
					background-color: rgb(199, 34, 34);
					border: none;
					box-shadow: none;
					width: calc(100%);
				}
			}
			.desc-button{
				width: 100%;
			}
			button{
				background-color: rgb(199, 34, 34);
				border: none;
				box-shadow: none;
				margin: 5px 0;
			}
          }
        }
      }
    }
  }
</style>

<style lang="less">
  .course-player-page{
	.vjs-custom-skin > .video-js .vjs-big-play-button{
		  top: 50%;
		  left: 50%;
		  transform: translate(-50%, -50%);
		  width: 96px !important;
		  height: 96px !important;
		  line-height: 96px !important;
		  border-radius: 50%;
	}
    .video-player{
      .vjs-fluid {
        padding-top: 57.32%;
      }
      .vjs-big-play-button{
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 96px;
        height: 96px;
        line-height: 96px;
        border-radius: 50%;
      }
      .vjs-big-play-button .vjs-icon-placeholder{
        font-size: 60px;
      }
      .vjs-fullscreen-control{
        .vjs-icon-placeholder{
          display: none;
        }
        .vjs-control-text{
          position: static;
        }
      }
    }
  }
  .custom__dialog.custom__dialog--w1000{
	@dialogHeight: calc(100vh);
    width: 100% !important;
	height: @dialogHeight !important;
	background-color: #fff;
    .ant-modal-content{
      border-radius: 0;
    }
    .ant-modal-close{
	  position: fixed;
	  top: unset;
      bottom: 80px;
      right: 80px;
	  width: 100px;
	  height: 100px;
    }
    .ant-modal-close-x{
    }
	.closeImg{
		width: 100px;
		height: 100px;
	}
    .ant-modal-header{
      padding: 30px 0;
      text-align: center;
      border-bottom: none;
    }
    .ant-modal-title{
      font-size: 24px;
      color: #2E2E2E;
    }
    .ant-modal-body{
      padding: 20px 20px 20px 20px;
	  // height: @dialogHeight;
      overflow: auto;
      .text{
        font-size: 18px;
        color: #323C47;
        line-height: 30px;
        text-align: left;
        span{
          color: #CE2323;
        }
      }
      .textAlignCenter{
        text-align: center;
      }
      p.text{
        margin-bottom: 0;
      }
    }
  }
</style>